import { CatHeading } from '@blocks-react/components/Heading';
import { useTranslations } from 'next-intl';
import styles from '../request-equipment-service.module.scss';
import {
  Conditional,
  RequestServiceChangeDealer,
  RequestServiceImage
} from '@cat-ecom/pcc-components';
import { capitalizeText } from '@cat-ecom/common/utils/commonUtils';
import { LOCATION_MARKER } from '../constant';
import cx from 'classnames';

const RequestEquipmentServiceDealerInfo = ({
  dealerName,
  onDealerChange,
  dealerList,
  isMD
}) => {
  const t = useTranslations();
  const catlocationMarker = `${LOCATION_MARKER.imgUrl}${LOCATION_MARKER.desk}`;

  return (
    <div
      className={cx([
        'd-flex px-3 py-4 mx-3',
        styles['request-service__dealer-info__bg']
      ])}
    >
      <Conditional test={dealerName}>
        <div className={styles['dealer-location']}>
          <div className="d-flex align-items-center">
            <RequestServiceImage
              imageSrc={catlocationMarker}
              imageAlt={LOCATION_MARKER.imgAlt}
              classname={'mb-0 me-2'}
            />
            <CatHeading variant="label">
              <span className="u-color--Black">
                {t('REQUEST_SERVICE_LOCATION', {
                  0: capitalizeText(dealerName)
                })}
              </span>
            </CatHeading>
          </div>
          <Conditional test={dealerList?.length > 1}>
            <CatHeading
              variant="label"
              className="mt-2 mt-md-0 mx-4 px-1 mx-md-0 px-md-0"
            >
              <RequestServiceChangeDealer
                dealersList={dealerList}
                onChange={onDealerChange}
                label={t('ALP_CHANGE_DEALER')}
                isMD={isMD}
                buttonSize="sm"
                iconSize="sm"
              />
            </CatHeading>
          </Conditional>
        </div>
      </Conditional>
    </div>
  );
};

export default RequestEquipmentServiceDealerInfo;
